@let corporateDesign = corporateDesignService.corporateDesign();
@let currentStep = step();
<div class="border-b-standard-outline-medium mb-6 border-b-1 pt-6">
  <div
    class="flex flex-row justify-between gap-2"
    [attr.data-testid]="'ticket-configuration-progress-bar'">
    @for (progressPoint of progressBarContent(); track progressPoint) {
      <ng-container
        *ngTemplateOutlet="
          progressTracker;
          context: {
            label: progressPoint.label,
            active: currentStep >= progressPoint.stepIndex,
            current: currentStep === progressPoint.stepIndex,
            done: currentStep > progressPoint.stepIndex,
          }
        "></ng-container>
    }
  </div>
  <div
    class="flex flex-row py-5"
    [ngClass]="
      currentStep > 0 && !isCompletionStep()
        ? 'justify-between'
        : 'justify-end'
    ">
    @if (currentStep > 0 && !isCompletionStep()) {
      <aw-button
        [id]="'ticket-configuration-back'"
        [type]="'button'"
        [style]="'primary-alt'"
        [isDisabled]="currentStep === 0"
        [disabledText]="
          textStore.texts()
            | filterTexts: ERelationType.backDisabled : EEntityType.generic
            | language
        "
        (keydown.enter)="navigateBack()"
        (click)="navigateBack()">
        <span class="material-symbols-rounded mr-2">chevron_left</span>
        {{
          textStore.texts()
            | filterTexts: ERelationType.back : EEntityType.generic
            | language
        }}
      </aw-button>
    }
    <aw-button
      [id]="'cancel-ticket-configuration'"
      [type]="'button'"
      [style]="'primary-alt'"
      (keydown.enter)="cancelTicketConfiguration()"
      (click)="cancelTicketConfiguration()">
      <span class="material-symbols-rounded mr-2">{{
        isCompletionStep() ? 'arrow_back' : 'close'
      }}</span
      >{{
        textStore.texts()
          | filterTexts: actionTextRelation() : actionTextEntity()
          | language
      }}
    </aw-button>
  </div>
</div>

<ng-template
  #progressTracker
  let-label="label"
  let-active="active"
  let-current="current"
  let-done="done">
  <div
    class="w-full"
    [ngClass]="{
      'hidden md:block': !current,
    }"
    [style.opacity]="done ? '0.4' : '1'">
    <div
      class="bg-standard-outline-light hidden w-full pt-1 md:block"
      [attr.data-testid]="'ticket-configuration-line' | appendTestId: label"
      [ngStyle]="{
        background: active || done
          ? corporateDesignService.isDarkModeActive()
            ? corporateDesign.colorAdmixtures.dark_text_high
            : corporateDesign.primaryColor
          : corporateDesign.colorAdmixtures.dark_text_disabled,
      }"></div>
    <div
      class="flex flex-row items-center justify-center pt-2 md:justify-start">
      <div
        class="relative mr-3 rounded-full border-2 p-3"
        [ngStyle]="{
          background: active || done
              ? corporateDesignService.isDarkModeActive()
                ? corporateDesign.colorAdmixtures.dark_text_high
                : corporateDesign.primaryColor
              : corporateDesign.colorAdmixtures.dark_text_disabled,
          borderColor: active || done
              ? corporateDesignService.isDarkModeActive()
                ? corporateDesign.colorAdmixtures.dark_text_high
                : corporateDesign.primaryColor
              : corporateDesign.colorAdmixtures.dark_text_disabled,
        }">
        <div class="absolute top-0 right-0 bottom-0 left-0 flex flex-row items-center justify-center">
          @if (done) {
            <span class="material-symbols-rounded text-sm text-white">check</span>
          } @else if (active) {
            <div class="h-2.5 w-2.5 rounded-full bg-white"></div>
          }
        </div>
      </div>
      <div
        [attr.data-testid]="'ticket-configuration-step' | appendTestId: label"
        [ngClass]="{
          'text-standard-outline-light': !active,
        }"
        [ngStyle]="{
          color: active || done
            ? corporateDesignService.isDarkModeActive()
              ? corporateDesign.colorAdmixtures.dark_text_high
              : corporateDesign.primaryColor
            : corporateDesign.colorAdmixtures.dark_text_disabled,
        }">
        {{ label }}
      </div>
    </div>
  </div>
</ng-template>
